




















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';

import { Button, Icon } from '@/components/core';
import Playlist from '@/components/playlist.vue';
import { promisify } from '@/utils';

@Component({
  components: { Button, Icon, Playlist },
})
export default class Playlists extends Vue {
  @Prop({ default: () => ({}) }) private mods!: Hash;

  @State('player') private player: IPlayerData;
  @State('playlists') private playlists: IPlaylistCollection;

  private blockName: string = 'playlists';

  private openedPlaylist: IPlaylistData = null;

  private get activePlaylistId() {
    if (this.openedPlaylist != null) return this.openedPlaylist.id;
    if (this.player.activePlaylist == null) return null;
    this.openedPlaylist = this.player.activePlaylist;
    return this.openedPlaylist.id;
  }

  @Mutation('setTitleToPlaylist') private setTitleToPlaylist: MutationMethod;
  @Mutation('createPlaylist') private createPlaylist: MutationMethod;
  @Mutation('deletePlaylist') private deletePlaylist: MutationMethod;
  @Mutation('updateActivePlaylist') private updateActivePlaylist: MutationMethod;
  @Mutation('updateState') private updateState: MutationMethod;

  private setActivePlaylist(playlist: IPlaylistData) {
    if (this.activePlaylistId === playlist.id) return;
    this.openedPlaylist = playlist;
    if (this.player.activePlaylist == null) this.updateActivePlaylist(playlist);
  }

  private updateTitle(event: Event) {
    const title = (event.target as HTMLSpanElement).textContent;
    if (this.player.activePlaylist.name === title) return;
    this.setTitleToPlaylist({
      id: this.activePlaylistId,
      title,
    });
  }

  private async createNewPlaylist(event: Event) {
    const title = (event.target as HTMLSpanElement).textContent;
    (event.target as HTMLSpanElement).textContent = 'Add';
    if (title.trim().length === 0) return;
    const playlist = await promisify(this.createPlaylist, {
      title,
    });
    this.setActivePlaylist(playlist);
  }

  private async deleteExistPlaylist(playlist: IPlaylistData) {
    this.deletePlaylist({ id: playlist.id });
    // @TODO Need implement logic for reset player if deleted active playlist
    if (this.player.activePlaylist != null && this.player.activePlaylist.id === playlist.id) {
      this.updateState('isStopped');
      this.updateActivePlaylist(Object.values(this.playlists)[0]);
    }
    if (this.activePlaylistId === playlist.id) {
      const activePlaylist = this.player.activePlaylist || Object.values(this.playlists)[0];
      if (activePlaylist != null) this.setActivePlaylist(activePlaylist);
      else this.openedPlaylist = null;
    }
  }

  private clearAddButtonText(event: Event) {
    requestAnimationFrame(() => {
      (event.target as HTMLSpanElement).textContent = '';
    });
  }

  private focusSpan(event: Event) {
    ((event.currentTarget as HTMLElement).lastElementChild as HTMLElement).focus();
  }
}
